import { gql, useMutation } from "@apollo/client";

import { FragmentDefiner } from "../../../GlobalHooks/useReadFragment";
import { useState } from "react";

export const FRAGMENT_TECHNICAL_SHEET = new FragmentDefiner(
	"Property",
	`
    technicalSheet{
        field   
        text
        value
    }
    project{id}
`
);

const SEND_LEAD_MUTATION = gql`
	mutation sendLead($input: LeadInput!) {
		sendLead(input: $input) {
			id
		}
	}
`;

interface ContactInput {
	property_id: number;
	source: number;
	type: string;
	financing_information: boolean;
	message?: string;
	visit_type?: string;
	date?: string;
	utm_args?: UtmArgs;
	isAutoGenerated?: boolean;
}

interface UtmArgs {
	utm_content?: string | string[];
	utm_source?: string | string[];
	utm_medium?: string | string[];
	utm_campaign?: string | string[];
}

export function useTechnicalSheet({ id, utm = null }) {
	const [formCompleted, setFormCompleted] = useState(false);
	const [sendLeadMutation] = useMutation(SEND_LEAD_MUTATION, {
		onError: error => {
			console.log(error);
		},
		onCompleted: () => setFormCompleted(true),
	});

	const sendLead = async (field: string) => {
		let input: ContactInput = {
			type: "PROPERTY",
			property_id: id,
			message: field,
			source: 14,
			isAutoGenerated: true,
			financing_information: false,
		};

		if (utm && (utm.utm_campaign || utm.utm_content || utm.utm_medium || utm.utm_source)) {
			input.utm_args = {};
			if (utm.utm_campaign) {
				input.utm_args.utm_campaign = utm.utm_campaign;
			}
			if (utm.utm_content) {
				input.utm_args.utm_content = utm.utm_content;
			}
			if (utm.utm_medium) {
				input.utm_args.utm_medium = utm.utm_medium;
			}
			if (utm.utm_source) {
				input.utm_args.utm_source = utm.utm_source;
			}
		}

		return sendLeadMutation({
			variables: {
				input,
			},
		});
	};

	return {
		sendLead,
		formCompleted,
	};
}
